<template>
  <div class="">
  <Modal
    v-model="currValue"
    width="700"
    :title="title"
    :mask-closable="false"
    :loading="loading"
    @on-ok="save()"
  >
    <Form
      ref="orderForm"
      label-position="right"
      :label-width="120"
      :rules="formRules"
      :model="form"
      >
      <FormItem
        label="套餐人数"
        label-for="packageId"
        prop="packageId"
        >
        <!-- 购买 展示所有套餐 -->
        <RadioGroup
          v-if="type === 1"
          v-model="form.packageId"
          vertical
          >
          <Radio
            v-for="(task, index) in packageList"
            :label="task.value + ''"
            :key="task.value"
            >
            {{task.name}}
          </Radio>
        </RadioGroup>
        <!-- 升级 只能往更多人数的套餐升级 -->
        <RadioGroup
          v-if="type === 2"
          v-model="form.packageId"
          vertical
          >
          <Radio
            v-for="(task, index) in packageList"
            :label="task.value + ''"
            :key="task.value"
            :disabled="task.value <= currPackageId"
            >
            {{task.name}}
          </Radio>
        </RadioGroup>
        <!-- 续费 不需要选择套餐 -->
        <Radio
          v-if="type === 3"
          :value="true"
          disabled
        >{{selectPackage.name}}</Radio>
      </FormItem>
      <FormItem
        label="使用年限"
        label-for="useYearType"
        prop="useYearType"
        v-if="type !== 2"
        >
        <RadioGroup
          v-model="form.useYearType"
          vertical
          >
          <Radio label="1">1年</Radio>
          <Radio label="2">2年(赠半年)</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem
        label="官网价格"
        label-for="officeManey"
        >
        <label slot="label"><font class="form-red-star"></font>官网价格
          <Tooltip  placement="bottom">
            <Icon type="ios-help-outline" class="ios-help" style="color:#3ccba6;"></Icon>
            <div slot="content">
              <p>官网价格= 套餐实际订购价*折扣-（原套</p>
              <p>餐支付价/总天数）*剩余天数</p>
            </div>
          </Tooltip>
        </label>
        <span>{{'￥' + (selectPackage.amount)*(form.useYearType)}}</span>
      </FormItem>
      <FormItem
        label="客户成交价格"
        label-for="customerPrice"
        prop="customerPrice"
        >
        <Input
          placeholder="请输入客户成交价格"
          element-id="customerPrice"
          v-model="form.customerPrice"
        ></Input>
      </FormItem>
      <FormItem
        label="代理价格"
        label-for="agentManey"
        >
        <label slot="label"><font class="form-red-star"></font>代理价格
          <Tooltip  placement="bottom">
            <Icon type="ios-help-outline" class="ios-help" style="color:#3ccba6;"></Icon>
            <div slot="content">
              <p>代理价格 = 官网价格*代理折扣</p>
            </div>
          </Tooltip>
        </label>
        <span>{{'￥' + (selectPackage.amount)*(form.useYearType)*(user.isPayDeposit ? user.discount / 100 : 1)}}</span>
      </FormItem>
      <FormItem
        label=""
        label-for="specialOrder"
        >
        <Checkbox
          v-model="form.isSpecial"
          :true-value="1"
          :false-value="0"
        >特殊订单</Checkbox>
      </FormItem>
      <template v-if="form.isSpecial === 1">
        <FormItem
          label="代理成交价格"
          label-for="specialAgentPrice"
          prop="specialAgentPrice"
          >
          <Input
            placeholder="请输入代理成交价格"
            element-id="specialAgentPrice"
            v-model="form.specialAgentPrice"
          ></Input>
        </FormItem>
        <FormItem
          label="特殊说明"
          label-for="specialRemark"
          prop="specialRemark"
          >
          <Input
            element-id="specialRemark"
            v-model="form.specialRemark"
            type="textarea"
            placeholder="请输入特殊说明"
            >
          </Input>
        </FormItem>
      </template>
      <FormItem
        v-if="user.isPayDeposit === 0"
        >
        <span>由于您未交保证金，提交订单会按官网价格进行扣除，订单成交后两个月返还剩余款项</span>
      </FormItem>
   </Form>
</Modal>
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // 类型 1购买 2升级 3续费
    type: {
      type: Number
    },
    // 如果是升级或续费 需获取当前已购买的套餐
    currPackageId: {
      type: Number
    },
    // 客户corpid
    corpid: {
      type: String,
      required: true
    },
    // 以下为代理商业务员编辑时使用参数
    useYearType: {
      type: [String, Number],
      default: '1'
    },
    customerPrice: {
      type: [String, Number],
      default: ''
    },
    isSpecial: {
      type: Number,
      default: 0
    },
    specialAgentPrice: {
      type: [String, Number],
      default: ''
    },
    specialRemark: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currValue: this.value,
      packageList: [],
      form: {
        type: this.type,
        corpid: '',
        packageId: '1',
        useYearType: '1',
        customerPrice: '',
        isSpecial: 0,
        specialAgentPrice: '',
        specialRemark: '',
        id: ''
      },
      formRules: {
        packageId: [
          { required: true, message: '请选择套餐', trigger: 'change' }
        ],
        useYearType: [
          { required: true, message: '请选择使用年限', trigger: 'change' }
        ],
        customerPrice: [
          { required: true, message: '请输入客户成交价格', trigger: 'blur' }
        ],
        specialAgentPrice: [
          { required: true, message: '请输入代理成交价格', trigger: 'blur' }
        ],
        specialRemark: [
          { required: true, message: '请输入特殊说明', trigger: 'blur' }
        ]
      },
      loading: true
    }
  },
  computed: {
    ...mapState('user', [
      'user'
    ]),
    title () {
      if (this.type === 1) return '购买'
      if (this.type === 2) return '升级'
      if (this.type === 3) return '续费'
    },
    // 选中的套餐
    selectPackage () {
      let pack = this.packageList.filter(item => (item.value + '') === this.form.packageId)
      return pack.length > 0 ? pack[0] : {}
    }
  },
  watch: {
    value (val) {
      this.currValue = val
      // 每次打开弹窗需要重新赋值
      this.form.type = this.type
      this.form.packageId = this.currPackageId
      this.form.corpid = this.corpid
      if (this.type === 2 && this.currPackageId < 8) {
        this.form.packageId += 1
      }
      this.form.packageId += ''

      // 以下为代理商业务员编辑时使用参数
      this.form.useYearType = this.useYearType + ''
      this.form.customerPrice = this.customerPrice + ''
      this.form.isSpecial = this.isSpecial
      this.form.specialAgentPrice = this.specialAgentPrice + ''
      this.form.specialRemark = this.specialRemark + ''
      this.form.id = this.id + ''
    },
    currValue (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    // 保存编辑数据
    save () {
      this.loading = false
      setTimeout(() => {
        this.loading = true
      }, 100)
      this.$refs['orderForm'].validate((valid) => {
        if (valid) {
          if (!this.form.id) {
            // 新增
            this.$http.post('/order', this.form).then(res => {
              if (res.success) {
                this.$Message.success('提交成功')
                this.currValue = false
                this.$emit('callback')
              } else {
                this.$Message.error(res.message)
              }
            })
          } else {
            // 编辑
            this.$http.put('/order', this.form).then(res => {
              if (res.success) {
                this.$Message.success('提交成功')
                this.currValue = false
                this.$emit('callback')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        }
      })
    }
  },
  created () {
    this.$http.get('/dropdown/chargePackage').then(res => {
      this.packageList = res.data
    })
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/customManage/agCustomList/OrderModal.vue